import { handleError, handleSuccess, triggerDelete, triggerGet, triggerPost, triggerPut } from './utils';

// Delete a Class
const deleteClassApiRequest = async id => {
  const apiResponse = await triggerDelete(`/business/classes/${id}`);

  if (apiResponse.status === 204) {
    return {
      success: true,
      data: [],
      report: {},
    };
  }

  return handleError({
    apiResponse,
  });
};

const classesCheckApiRequest = async data => {
  const apiResponse = await triggerPost('/business/classes/check', data);
  const responseData = await apiResponse.json();

  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }

  return handleError(responseData);
}; // Get all Groups for Services/Courses/Events

// Return all Classes
const getClassesApiRequest = async (id, isPublic = false) => {
  const apiResponse = await triggerGet(`/${isPublic ? 'public' : 'business'}/services/${id}/classes/`, !isPublic);
  const responseData = await apiResponse.json();

  if (isPublic && responseData.report.status === 404) {
    return { success: true, data: [], report: {}, result: false };
  }

  if (responseData.report.status === 200) {
    const { data } = handleSuccess(responseData);
    const newData = data.filter(x => +x.classesServicesId === +id && (!isPublic || x.classesActive === 'Y'));

    return {
      success: true,
      data: newData,
    };
  }

  return handleError(responseData);
};

// Change class active - status
const toggleClassActiveStatusApiRequest = async id => {
  const apiResponse = await triggerGet(`/business/classes/status/${id}`);

  if (apiResponse.status === 200) {
    return {
      success: true,
      data: [],
      report: {},
    };
  }

  return {
    success: false,
  };
};

// Change class order
const changeClassesOrderApiRequest = async newArr => {
  const id = newArr[0].classesServicesId;
  const ids = {
    classesOrder: newArr.map(x => x.classesId).join(','),
  };
  const apiResponse = await triggerPut(`/business/services/${id}/classes/`, ids);

  if (apiResponse.status === 200) {
    return {
      success: true,
      data: newArr,
      report: {},
    };
  }

  return {
    success: false,
  };
};

export { changeClassesOrderApiRequest, classesCheckApiRequest, deleteClassApiRequest, getClassesApiRequest, toggleClassActiveStatusApiRequest };
